import * as React from "react";
import Box from "@mui/material/Box";
import { Modal, ModalBody } from "react-bootstrap";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { postPdfAtomizer } from "../../../API/api";
import styles from "./AtomizerModal.module.css";
import { initialState } from "../../../Reducer/atomizerPageReducer";
// import { Close } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import Close from "@mui/icons-material/Close";
import { Stack } from "@mui/material";
import VizButton from "../../VizButtons/VizButton";
import VizParagraph from "../../VizParagraph/VizParagraph";

const textStyles1 = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word', overflowWrap: 'break-word',
  textAlign: "left",
  display: "flex",
  justifyContent: "center",
  width: "100%"


};
const modalTitleStyle = {
  color: "rgb(42, 54, 74)",
  fontSize: "20px",
  fontFamily: "Helvetica",
};
export default function AtomizerModal() {
  const dispatch = useDispatch();

  const {
    handleSoId,
    advanceFilterModalToggle,
    handleLoadingSpinner,
    handlePayload,
    initailPage,
    handleResetState,
  } = bindActionCreators(Actions, dispatch);

  const state = useSelector((state) => state.atomizer);
  const modalState = useSelector((state) => state.domain);

  const handleClickButton = (oldSoId, binaryFile) => {
    advanceFilterModalToggle({ bool: false, value: "" });
    // handleLoadingSpinner(true);
    handleSoId(oldSoId);
    handlePayload(true);
    if (oldSoId !== null) {
      handleLoadingSpinner(true);
      postPdfAtomizer(state, true, oldSoId);
    }
    if (oldSoId === null) {
      handleLoadingSpinner(true);
      postPdfAtomizer(state, false);
    }
  };

  const handleClose = () => {
    advanceFilterModalToggle({ bool: false, value: "" });
    handleLoadingSpinner(false);
    handleResetState(initialState);
  };

  return (
    <>

      <Modal show={modalState.modalState}
        onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
        centered={true}
        size={"lg"}
        style={{ marginTop: "-50px" }}
      // scrollable={true}
      >
        <Modal.Header closeButton>
          <Modal.Title style={modalTitleStyle}>
            <span>
              <i class="fa fa-bolt" aria-hidden="true"> </i> &nbsp;&nbsp;Similar Files
            </span>


          </Modal.Title>
        </Modal.Header>
        <ModalBody>
          {/* <div className="row" style={{ paddingLeft: '3.0rem', paddingRight: '3.0rem', paddingBottom: '5px', textAlign: 'center' }}>
                         <div className="container">
                             <p style={{ fontSize: '16px', fontWeight: '300' }}>Are you sure you want to Delete this Answer?</p>
                             <p style={{ fontSize: '14px', fontWeight: '300' }}>The Seeker will no longer be able to view this answer</p>
      
      
                             {!isLoading && <div>
                                 <button className="cancelBtn" onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>No</button>&nbsp;<button className="rerouteBtn" onClick={() => onClickButtons()}>Yes</button>
                             </div>}
                             {isLoading &&
                                 <div>
                                     <button className="loadingpublishbutton" disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Deleting...</button>
                                 </div>}
                         </div>
                     </div> */}


          <div className="row" style={{ paddingLeft: '3.0rem', paddingRight: '3.0rem', paddingBottom: '5px', textAlign: 'center' }}>
            <div className="container">

              <div style={{ width: "100%", justifyContent: "center" }}>
                {state?.Response
                  ? state?.Response.map((item, ind) => {
                    return (
                      <>
                        <div>
                          <p style={textStyles1}> Is this new Version of: {item?.docName}?{" "}
                            {Math.round(item?.score * 1000) / 10}%</p>
                        </div>
                        <div style={{display:"flex",gap:"10px",justifyContent:"center"}}>
                            <button style={{
                              padding: '8px 12px 8px 12px',
                              borderRadius: '6px',
                              fontSize: '14px',
                              lineHeight: '24px',
                              fontWeight: 400,
                              boxShadow: ' 0px 1px 2px 0px #1018280D',
                              color: '#2A364A',
                              border: '1px solid  #fff',
                              height: '40px',
                              minWidth: '88px',
                              background: " #F6F7F8",
                              marginBottom: '14px',
                              fontWeight: 400,
                              border: " 1px solid #E0E2E6"


                              //  font-weight: 400;          
                            }} onClick={() => handleClickButton(null)}>No
                            </button>&nbsp;<button
                              style={{
                                padding: '8px 12px 8px 12px',
                                borderRadius: '6px',
                                fontSize: '14px',
                                lineHeight: '24px',
                                fontWeight: 400,
                                boxShadow: '0px 1px 2px 0px #1018280D',
                                color: '#FFFFFF',
                                border: '1px solid  #fff',
                                height: '40px',
                                minWidth: '88px',
                                background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                marginBottom: '14px',
                                cursor: "pointer"
                              }}
                              onClick={() => handleClickButton(item?.soId)}>Yes</button>
                          </div>
                      </>
                    );
                  })
                  : null}

              </div>

            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
